import React, { useState } from 'react';
import API from '../api';
import { toast } from 'react-hot-toast';

export default function ResetPassword() {
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!email || !newPassword || !confirmPassword) {
      toast.error('ກະລຸນາຕື່ມຂໍ້ມູນໃຫ້ຄົບຖ້ວນ');
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error('ລະຫັດຜ່ານບໍ່ຕົງກັນ');
      return;
    }

    if (newPassword.length < 6) {
      toast.error('ລະຫັດຜ່ານຕ້ອງມີກຳນົດ 6 ຕົວອັກສອນຂຶ້ນໄປ');
      return;
    }

    setLoading(true);
    try {
      const response = await API.post('/auth/reset-password', {
        email,
        newPassword
      });
      toast.success(response.data.message || 'ລີເຊັດລະຫັດຜ່ານສຳເລັດ');
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
    } catch (error) {
      toast.error(error.response?.data?.message || 'ບໍ່ສາມາດລີເຊັດລະຫັດຜ່ານໄດ້');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 shadow-2xl rounded-2xl p-8">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 dark:bg-blue-900 rounded-full mb-4">
            <span className="text-3xl">🔐</span>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">
            ລີເຊັດລະຫັດຜ່ານ
          </h2>
          <p className="text-gray-600 dark:text-gray-400 text-sm">
            ກຣອກອີເມວແລະລະຫັດຜ່ານໃໝ່ຂອງທ່ານ
          </p>
        </div>

        <form onSubmit={handleResetPassword} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              ອີເມວ
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your.email@example.com"
              className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              ລະຫັດຜ່ານໃໝ່
            </label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="ກຳນົດ 6 ຕົວອັກສອນຂຶ້ນໄປ"
              className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              ຍືນຍັນລະຫັດຜ່ານ
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="ກຣອກລະຫັດຜ່ານອີກຄັ້ງ"
              className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-lg transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'ກຳລັງລີເຊັດ...' : '✔️ ລີເຊັດລະຫັດຜ່ານ'}
          </button>

          <div className="text-center mt-4">
            <a href="/login" className="text-sm text-blue-600 hover:text-blue-700 dark:text-blue-400">
              ← ກັບໄປຫນ້າເຂົ້າສູ່ລະບົບ
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}
